export const getIntervalIndex = (index, count) => index % count;
